window.linkEnablingStreets = function (enablingSelector, streetSelector, pairs) {
  const $enabling = $(enablingSelector)
  const $street = $(streetSelector)

  if (!$enabling.length || !$street.length || !Array.isArray(pairs)) {
    return
  }

  const catalog = $select =>
    $select
      .find('option')
      .toArray()
      .filter(option => option.value !== '')
      .map(option => ({ id: option.value, text: option.text.trim() }))
  const enablings = catalog($enabling)
  const streets = catalog($street)

  const related = (value, from, to) =>
    new Set(pairs.filter(pair => String(pair[from]) === String(value)).map(pair => String(pair[to])))

  function fill($select, items, allowed) {
    const current = $select.val()
    const options = allowed ? items.filter(item => allowed.has(item.id)) : items
    const placeholder = $select.find('option[value=""]').first().text()

    $select.empty().append(new Option(placeholder, ''))
    options.forEach(item => $select.append(new Option(item.text, item.id, false, item.id === current)))

    if (current && !options.some(item => item.id === current)) {
      $select.val('')
    }
    $select.trigger('change.select2')
  }

  const refreshStreets = () => fill($street, streets, $enabling.val() ? related($enabling.val(), 0, 1) : null)
  const refreshEnablings = () => fill($enabling, enablings, $street.val() ? related($street.val(), 1, 0) : null)

  $enabling.on('change', () => {
    refreshStreets()
    refreshEnablings()
  })
  $street.on('change', () => {
    refreshEnablings()
    refreshStreets()
  })

  refreshStreets()
  refreshEnablings()
}
